module.exports = __webpack_public_path__ + "static/media/Artboard4.5df25021.png";